export default __webpack_public_path__ + "static/Globhe_logotype_2022_black-a18ac141502b0069778b317f942854e1.png";